import theme from '../../theme';

const WeatherCloudy = ({ color = theme.colors.gray, width = '22', height = '22' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.4999 21H8.99992C7.70178 20.9997 6.42931 20.6384 5.32469 19.9565C4.22008 19.2746 3.32684 18.2989 2.74479 17.1386C2.16274 15.9783 1.91481 14.679 2.02871 13.3858C2.14261 12.0927 2.61384 10.8567 3.38976 9.81598C4.16568 8.77526 5.21571 7.97079 6.42252 7.49249C7.62932 7.01418 8.94536 6.88087 10.2236 7.10747C11.5018 7.33406 12.6918 7.91162 13.6606 8.77561C14.6295 9.6396 15.339 10.756 15.7099 12H17.4999C18.0909 12 18.676 12.1164 19.222 12.3425C19.768 12.5687 20.264 12.9002 20.6819 13.318C21.0998 13.7359 21.4312 14.232 21.6574 14.7779C21.8835 15.3239 21.9999 15.9091 21.9999 16.5C21.9999 17.091 21.8835 17.6761 21.6574 18.2221C21.4312 18.768 21.0998 19.2641 20.6819 19.682C20.264 20.0998 19.768 20.4313 19.222 20.6575C18.676 20.8836 18.0909 21 17.4999 21Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.0001 10C22.0001 9.20435 21.684 8.44129 21.1214 7.87868C20.5588 7.31607 19.7957 7 19.0001 7H16.7931C16.4538 5.80633 15.721 4.76239 14.7136 4.03772C13.7062 3.31306 12.4835 2.95022 11.2439 3.00813C10.0043 3.06605 8.82068 3.54131 7.88525 4.35675C6.94983 5.17218 6.31754 6.27989 6.09106 7.5"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default WeatherCloudy;
